import * as React from 'react';
import { Node } from 'slate';
import styled from 'styled-components';

import { useBlankEditorDoTest } from '../../BlogEditor/OnlineTestEditorPlugin.presets';
import { colorsV2 } from '../../colors-v2';
import { DolEditor } from '../../DolEditor/DolEditor';
import { BlankItem } from '../type';
import { BlankChange } from './Blank';
import { ToolbarDoingTestV2 } from '../../ToolbarDoingTestV2/ToolbarDoingTestV2';

export interface BlankEditorDoTestProps {
  no: number;
  editorValue?: Node[];
  onBlankChange?: (input: BlankChange) => void;
  onEditorChange?: (value: string) => void;
  blanks: BlankItem[];
  blankValues?: BlankChange[];
  className?: string;
  useBlankDash?: boolean;
  showQuestionNo?: boolean;
  withToolBar?: boolean;
}

export const BlankEditorDoTest = (props: BlankEditorDoTestProps) => {
  const {
    no,
    editorValue,
    onBlankChange,
    onEditorChange,
    blanks,
    blankValues = [],
    useBlankDash,
    showQuestionNo = true,
    className,
    withToolBar,
  } = props;
  const [editor, setEditor] = React.useState(null);

  const { plugins, editorChains } = useBlankEditorDoTest({
    blanks,
    blankValues,
    no,
    onBlankChange,
    useBlankDash,
    showQuestionNo,
  });

  return (
    <Main className={className}>
      <DolEditor
        onEditorChange={(changeValue, _) => {
          onEditorChange?.(JSON.stringify(changeValue));
        }}
        forceValue
        withToolbar={withToolBar && <ToolbarDoingTestV2 />}
        initialValue={editorValue}
        readOnly
        editor={editor}
        onMounted={setEditor}
        plugins={plugins}
        renderElementDeps={[no, showQuestionNo, useBlankDash]}
        editorChains={editorChains}
      />
    </Main>
  );
};

const Main = styled.div`
  .dol-editor {
    color: ${colorsV2.black100};
    font-weight: 400;
    line-height: 28px;
    font-size: 14px;
    margin: 0;
    &:not(:last-child) {
      margin-bottom: 20px;
    }
    > span {
      line-height: 28px;
    }
  }
`;

export const EditableContainer = styled.div`
  background-color: ${colorsV2.white100};
  box-sizing: border-box;
`;
